import type { ShowSnackbar, ShowSnackbarEventPayload, SnackbarOptions } from './types';
import { SHOW_SNACKBAR_EVENT_TYPE } from './constants';

export const showSnackbar: ShowSnackbar = (label: string, options?: SnackbarOptions) => {
    dispatchEvent(
        new CustomEvent<ShowSnackbarEventPayload>(SHOW_SNACKBAR_EVENT_TYPE, {
            detail: {
                label: label || String(label),
                options,
            },
        }),
    );
};
